var VehicleModels = require('src/interlock/no-ui/data/vehicle-endpoint.js');

var NavDataAccess = function () {
    var dataObj = [];

    var sortDesc = function( a, b ) {
        return b - a;
    };

    var prettify = function(submodels) {
        var submodelMap = {};
        submodels.forEach(function(submodel) {
            if (typeof submodelMap[submodel.name] === 'object') {
                submodelMap[submodel.name].years.push(submodel.year);
            } else {
                submodelMap[submodel.name] = {};
                for(var k in submodel) {
                    switch(k) {
                    case 'year':
                        submodelMap[submodel.name]['years'] = [submodel[k]];
                        break;
                    default:
                        submodelMap[submodel.name][k] = submodel[k];
                        break;
                    }
                }
            }
        });

        // convert into array
        var arrayOfSubmodelsYears = [];
        for(var k in submodelMap) {
            submodelMap[k].years = submodelMap[k].years.sort(sortDesc);
            arrayOfSubmodelsYears.push(submodelMap[k]);
        }

        return arrayOfSubmodelsYears;
    };

    var getNewFutureModelYears = function(makeNiceName) {
        return VehicleModels.getSubmodelsYearsByMake(makeNiceName, 'name', 'PRE_PROD,NEW,NEW_USED')
            .then(prettify);
    };

    var getUsedModelYears = function(makeNiceName) {
        return VehicleModels.getSubmodelsYearsByMake(makeNiceName, 'name', 'NEW_USED,USED')
            .then(prettify);
    };

    var getNewModelYears = function(makeNiceName) {
        return VehicleModels.getSubmodelsYearsByMake(makeNiceName, 'name', 'NEW,NEW_USED')
            .then(prettify);
    };
    /* eslint-disable complexity */
    this.getModelYear = function(data, callback) {
        var makeNiceName = data.makeNiceName || '';
        var type = data.type || '';
        switch (type) {
        case 'newFuture':
            getNewFutureModelYears(makeNiceName).then(function(data){
                dataObj = data;
                callback(data);
            });
            break;
        case 'used':
            getUsedModelYears(makeNiceName).then(function(data){
                dataObj = data;
                callback(data);
            });
            break;
        case 'new':
            getNewModelYears(makeNiceName).then(function(data){
                dataObj = data;
                callback(data);
            });
            break;
        default:
            // do nothing
            break;
        }
    };
    /* eslint-enable complexity */

    this.getDataObj = function() {
        return dataObj;
    };
};

module.exports = new NavDataAccess();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav-data-access.js
// module id = 8
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14